var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_user_istructor",
    transform: "translate(-1048.000000, -31.000000)",
    stroke: "#EFB43F",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "line_user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(1049.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.342575,1.656875 C19.028075,0.343291667 16.929825,0.375375 15.615325,1.68895833 L2.35574167,14.944875 L0.687408333,21.3065417 L7.05090833,19.639125 L20.3104917,6.38320833 C21.6249917,5.069625 21.657075,2.971375 20.342575,1.656875 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2364667,2.06818333 L19.9316333,6.76243333",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3211833,3.98255 L18.01635,8.6768",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    points: "2.35565 14.9449667 5.64648333 16.3493 7.05448333 19.6346333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6688583,6.329675 L5.646025,16.3488417",
    id: "Stroke-9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditHover);
export default __webpack_public_path__ + "static/media/edit-hover.81f6630c56f510e670a87b034d53abe1.svg";
export { ForwardRef as ReactComponent };